export default __webpack_public_path__ + "static/media/7.87c3e6d3.png";